import { RouterState } from "react-router-redux";
import { AbstractGradingState, initialState as initialAbstractGradingState } from "./AbstractGradingState";
import { AbstractState, initialState as initialAbstractState } from "./AbstractState";
import { AdminAbstractState, initialState as initialAdminAbstractState } from "./AdminAbstractState";
import { AdminAbstractTypeReducer, AdminAbstractTypeState, initialAdminAbstractTypeState } from "./adminAbstractType";
import { AdminEmailTemplateState, initialState as initialAdminEmailTemplateState } from "./AdminEmailTemplateState";
import { AdminEventState, initialState as initialAdminEventState } from "./AdminEventState";
import { AdminMenuState, initialState as initialAdminMenuState } from "./AdminMenuState";
import { AdminNavListState, initialState as initialAdminNavListState } from "./AdminNavListState";
import { AdminPageListState, initialState as initialAdminPageListState } from "./AdminPageListState";
import { AdminTagReducer, AdminTagState, initialAdminTagState } from "./adminTag";
import { AlertReducer, AlertState, initialAlertState } from "./alert";
import { AuthState, initialState as initialAuthState } from "./AuthState";
import { CareerCenterState, initialState as initialCareerCenterState } from "./CareerCenterState";
import { ConnectionState, initialState as initialConnectionState } from "./ConnectionState";
import { CountryState, initialState as initialCountryState } from "./CountryState";
import { DbSubscriptionState, initialState as initialDbSubscriptionState } from "./DbSubscriptionState";
import { DocumentState, initialState as initialWindowSizeState } from "./DocumentState";
import { EventReducer, EventState, initialEventState } from "./event";
import { initialState as initialNavigationState, NavigationState } from "./NavigationState";
import { initialState as initialNotiState, NotificationState } from "./NotificationState";
import { initialState as initialPageState, PageState } from "./PageState";
import { initialState as initialSsrState, SsrState } from "./SsrState";
import * as allReducers from "../reducers";

// The top-level state object
export interface AppState {
    abstract: AbstractState;
    abstractGrading: AbstractGradingState;
    adminAbstracts: AdminAbstractState;
    adminAbstractType: AdminAbstractTypeState;
    adminEmailTemplates: AdminEmailTemplateState;
    adminEvents: AdminEventState;
    adminMenu: AdminMenuState;
    adminNavListState: AdminNavListState;
    adminPageListState: AdminPageListState;
    adminTag: AdminTagState;
    alert: AlertState;
    auth: AuthState;
    careerCenter: CareerCenterState;
    conn: ConnectionState;
    countries: CountryState;
    dbSubscriptions: DbSubscriptionState;
    doc: DocumentState;
    event: EventState;
    nav: NavigationState;
    notifications: NotificationState;
    page: PageState;
    router: RouterState;
    ssr: SsrState;
}

export const initialState: AppState = {
    abstract: initialAbstractState,
    abstractGrading: initialAbstractGradingState,
    adminAbstracts: initialAdminAbstractState,
    adminAbstractType: initialAdminAbstractTypeState,
    adminEmailTemplates: initialAdminEmailTemplateState,
    adminEvents: initialAdminEventState,
    adminMenu: initialAdminMenuState,
    adminNavListState: initialAdminNavListState,
    adminPageListState: initialAdminPageListState,
    adminTag: initialAdminTagState,
    alert: initialAlertState,
    auth: initialAuthState,
    careerCenter: initialCareerCenterState,
    conn: initialConnectionState,
    countries: initialCountryState,
    dbSubscriptions: initialDbSubscriptionState,
    doc: initialWindowSizeState,
    event: initialEventState,
    nav: initialNavigationState,
    notifications: initialNotiState,
    page: initialPageState,
    router: {
        location: null,
    },
    ssr: initialSsrState,
};

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding AppState property type.
export const reducers = {
    abstract: allReducers.AbstractReducer,
    abstractGrading: allReducers.AbstractGradingReducer,
    adminAbstracts: allReducers.AdminAbstractReducer,
    adminAbstractType: AdminAbstractTypeReducer,
    adminEmailTemplates: allReducers.AdminEmailTemplateReducer,
    adminEvents: allReducers.AdminEventReducer,
    adminMenu: allReducers.AdminMenuReducer,
    adminNavListState: allReducers.AdminNavListReducer,
    adminPageListState: allReducers.AdminPageListReducer,
    adminTag: AdminTagReducer,
    alert: AlertReducer,
    auth: allReducers.AuthReducer,
    careerCenter: allReducers.CareerCenterReducer,
    conn: allReducers.ConnectionReducer,
    countries: allReducers.CountryReducer,
    dbSubscriptions: allReducers.DbSubscriptionReducer,
    doc: allReducers.DocumentReducer,
    event: EventReducer,
    nav: allReducers.NavigationReducer,
    notifications: allReducers.NotificationReducer,
    page: allReducers.PageReducer,
    ssr: allReducers.SsrReducer,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export type AppThunkAction<TAction> = (dispatch: (action: TAction) => void, getState: () => AppState) => void;



// WEBPACK FOOTER //
// ./src/store/index.ts